import * as views from "../views";
import { i18nFormat } from "@/i18n.js";
// import RouterView from "@/core/components/RouteContainer.vue";
/**
 *
 * @param {Boolean} visible
 * @param {Boolean} search
 * @param {String} title
 * @param {String} domain
 */
let meta = (
  visible = true,
  breadcrumb = null,
  title = i18nFormat("t", "academy.title"),
  domain = null
) => ({
  headerVisible: visible,
  headerTitle: title,
  headerDomain: domain,
  allowAutoSidebar: true,
  breadcrums: breadcrumb
});

// () => import("@/modules/Tutorials/views/Layout")
// () => import("@/modules/Tutorials/views/Default")
// () => import("@/modules/Tutorials/views/Topics")
// () => import("@/modules/Tutorials/views/TopicDetail")

export default [
  {
    path: "tutorials",
    component: views.Layout,
    meta: meta(),
    children: [
      {
        path: "",
        name: "Tutorials",
        component: views.Default,
        meta: meta(true)
      },
      {
        path: "topics",
        name: "Topics",
        component: views.Topics,
        meta: meta(true, [
          { name: i18nFormat("t", "generals.tutorials"), to: "Tutorials" },
          { name: i18nFormat("t", "generals.topics") }
        ])
      },
      {
        path: "topic/:id",
        name: "TopicDetails",
        component: views.TopicDetail,
        meta: meta(true)
      }
    ]
  }
];
